import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useAppContext } from "../../context";
import WarningText from "../WarningText";

export default function InfoComponent() {

    const { sellCurrencyInfo, buyCurrencyInfo, buyCurrencyForInfo, showOnlineTab } = useAppContext();
    
    return (
        <>
            {showOnlineTab && <WarningText />}
            <Box
                sx={{
                    display: "flex",
                    justifyContent: { xs: "center", md: "flex-start" },
                    mt: 2,
                    maxWidth: "650px",
                    mx: "auto",
                }}
            >
                <Typography
                    className="font-helviteca"
                    sx={{
                        fontSize: "16px",
                        color: "#66A5F9 !important",
                    }}
                >
                    1 {sellCurrencyInfo} = {buyCurrencyForInfo !== undefined && buyCurrencyForInfo !== null && !isNaN(buyCurrencyForInfo as number) ? Number(buyCurrencyForInfo).toFixed(4) : "0.0000"} {buyCurrencyInfo}
                </Typography>
            </Box>
        </>
    );
}
